export default __webpack_public_path__ + "static/media/self.9ad13a92.jpg";